import React, {useRef} from 'react'
import Header from '../component/Header'
import HomeBanner from '../component/HomeBanner'
import BrowseHome from '../component/BrowseHome'
import RecommendedYou from '../component/RecommendedYou'
import HomeCTA from '../component/HomeCTA'
import BrowseCountry from '../component/BrowseCountry'
import ExploreResultLocations from '../component/ExploreResultLocations'
import HomeRealEstateAgentForm from '../component/HomeRealEstateAgentForm'
import HomePropertyTypeSelector from '../component/HomePropertyTypeSelector'
import Footer from '../component/Footer'
function Home() {
  const recommendedRef = useRef(null);
  return (
    <>
      <div className='main home-page'>
        <Header />
        <HomeBanner />
        <BrowseHome scrollToRecommended={() => recommendedRef.current?.scrollIntoView({ behavior: 'smooth' })} />
        <RecommendedYou ref={recommendedRef} />
        <HomeCTA />
        <HomePropertyTypeSelector />
        <BrowseCountry />
        <HomeRealEstateAgentForm />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  )
}
export default Home


